(() => {
  if (customElements.get('safecharge-mentor')) return;
  class SafeChargeMentor extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.querySelector('form');
      this.buy = this.querySelector('[data-buy]');
      this.sticky = this.querySelector('[data-sticky]');
      this.model = this.querySelector('[data-model]');
      this.thumbs = [...this.querySelectorAll('[data-gallery]')];
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-gallery]');
        if (thumb) this.showMedia(thumb);
        const pack = event.target.closest('[data-pack]');
        if (pack) this.selectPack(pack);
        if (event.target.closest('[data-sticky-buy]')) this.form.requestSubmit(this.buy);
        if (event.target.closest('[data-open-3d]')) {
          this.showMedia(this.thumbs.at(-1));
          this.querySelector('.scm__gallery').scrollIntoView({ behavior: this.reducedMotion() ? 'instant' : 'smooth', block: 'center' });
          this.thumbs.at(-1).focus({ preventScroll: true });
        }
        if (event.target.closest('[data-reset]')) this.model.cameraOrbit = '18deg 62deg 135%';
      }, options);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-pack]')) this.selectPack(event.target);
      }, options);
      this.querySelector('.scm__thumbs').addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const index = this.thumbs.indexOf(document.activeElement);
        if (index < 0) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.thumbs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.thumbs.length) % this.thumbs.length;
        this.thumbs[next].focus();
        this.showMedia(this.thumbs[next]);
      }, options);
      this.model.addEventListener('load', () => {
        if (this.thumbs.at(-1).getAttribute('aria-pressed') === 'true') this.hint('Drag to rotate. Scroll or pinch to zoom.');
      }, options);
      this.model.addEventListener('error', () => this.hint('3D could not load. You can still inspect the front, rear and close-up photos.'), options);
      this.updateSticky = () => {
        const belowBuy = this.buy.getBoundingClientRect().bottom < 0;
        const final = document.querySelector('safecharge-final-cta');
        const finalRect = final?.getBoundingClientRect();
        this.sticky.hidden = !belowBuy || (finalRect && finalRect.top < innerHeight);
      };
      document.addEventListener('scroll', this.updateSticky, { capture: true, passive: true, signal: this.controller.signal });
      window.addEventListener('resize', this.updateSticky, options);
      this.updateSticky();
    }
    disconnectedCallback() { this.controller?.abort(); this.ready = false; }
    reducedMotion() { return matchMedia('(prefers-reduced-motion: reduce)').matches; }
    hint(text) { this.querySelector('[data-gallery-hint]').textContent = text; }
    selectPack(pack) {
      this.querySelector('[data-variant-id]').value = pack.value;
      this.querySelector('[data-price]').textContent = pack.dataset.price;
      this.querySelector('[data-sticky-price]').textContent = pack.dataset.price;
      const compare = this.querySelector('[data-compare]');
      compare.textContent = pack.dataset.compare;
      compare.hidden = !pack.dataset.compare;
      const saving = this.querySelector('[data-saving]');
      saving.textContent = pack.dataset.saving ? `Save ${pack.dataset.saving}%` : '';
      saving.hidden = !pack.dataset.saving;
      const available = pack.dataset.available === 'true';
      this.buy.disabled = !available;
      this.querySelector('[data-buy-label]').textContent = available ? 'Add to cart' : 'Sold out';
      const stickyBuy = this.querySelector('[data-sticky-buy]');
      stickyBuy.disabled = !available;
      stickyBuy.textContent = available ? 'Add to cart' : 'Sold out';
    }
    showMedia(thumb) {
      const is3d = thumb.dataset.gallery === '3d';
      const isGuide = thumb.dataset.guide === 'true';
      this.querySelector('.scm__stage').classList.toggle('scm__stage--guide', isGuide);
      const isVideo = thumb.dataset.gallery === 'video';
      const videoPanel = this.querySelector('[data-video-panel]');
      if (videoPanel) { videoPanel.hidden = !isVideo; if (!isVideo) videoPanel.querySelector('video')?.pause(); }
      this.thumbs.forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
      const img = this.querySelector('[data-main-image]');
      img.hidden = is3d || isVideo;
      this.querySelector('[data-model-panel]').hidden = !is3d;
      const real = thumb.dataset.real === 'true';
      this.querySelector('[data-stage-note]').hidden = true;
      this.querySelector('[data-media-label]').hidden = isVideo || isGuide;
      this.querySelector('[data-stage-note]').textContent = real ? this.dataset.realLabel : this.dataset.renderLabel;
      this.querySelector('[data-media-label]').textContent = is3d ? 'Explore every angle' : real ? this.dataset.realLabel : this.dataset.renderLabel;
      if (is3d) {
        this.hint(this.model.loaded ? 'Drag to rotate. Scroll or pinch to zoom.' : 'Loading your interactive 3D view…');
        if (!this.model.getAttribute('src')) this.model.setAttribute('src', this.model.dataset.src);
        if (thumb.dataset.orbit) this.model.cameraOrbit = thumb.dataset.orbit;
        if (!customElements.get('model-viewer') && !document.querySelector('script[data-scm-model-library]')) {
          const script = document.createElement('script');
          script.type = 'module';
          script.src = this.dataset.modelScript;
          script.dataset.scmModelLibrary = '';
          script.onerror = () => this.hint('3D could not load. Please use the product photos.');
          document.head.append(script);
        }
      } else if (isVideo) {
        this.hint(this.dataset.realLabel);
      } else {
        img.src = this.reducedMotion() && thumb.dataset.still ? thumb.dataset.still : thumb.dataset.src;
        img.alt = thumb.dataset.alt;
        img.classList.toggle('scm__main-image--use', real);
        this.hint(thumb.dataset.note || (isGuide ? 'Rendered from the approved 3D model. Phone and separation spacing are illustrative.' : this.dataset.galleryDisclosure));
      }
    }
  }
  customElements.define('safecharge-mentor', SafeChargeMentor);
})();


